import React, { useEffect, useState } from "react";
import {
  Day,
  Inject,
  Month,
  ScheduleComponent,
  ViewDirective,
  ViewsDirective,
  Week,
  WorkWeek,
} from "@syncfusion/ej2-react-schedule";
import { registerLicense } from "@syncfusion/ej2-base";
import { convertTimeStamptoDate } from "../../../utils/EleghoUtils";
import { getAllDocsSnap } from "../../../utils/firebase/Firebase.utils";
import { FaCalendarAlt, FaTimesCircle } from "react-icons/fa";
import { BsCalendarWeek } from "react-icons/bs";

registerLicense(
  "ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5RdkdjX35ddHNSRWNY"
);

export default function DayViewCalendar({ date, setDateSelected, bookings }) {
  const [categoryColors, setCategoryColors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFacilities = async () => {
      await getAllDocsSnap("facilities", (facilities) => {
        const colors = facilities.map((facility, index) => {
          const hue = (index * 137.5) % 360;
          return {
            bookingType: facility.name,
            color: `hsl(${hue}, 70%, 50%)`,
          };
        });
        setCategoryColors(colors);
        setIsLoading(false);
      });
    };

    fetchFacilities();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64 text-[#363062]">
        <div className="animate-pulse flex flex-col items-center">
          <BsCalendarWeek className="text-3xl mb-2" />
          <span className="text-sm">Loading calendar...</span>
        </div>
      </div>
    );
  }

  const createDateTime = (date, time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const dateTime = new Date(convertTimeStamptoDate(date));
    dateTime.setHours(hours, minutes, 0, 0);
    return dateTime;
  };

  const data = bookings.map((item) => {
    const facilityColor =
      categoryColors.find((color) => color.bookingType === item.bookingType)
        ?.color || "#808080";

    return {
      id: item.id,
      Description: "Booked",
      isReadOnly: true,
      Subject: "Booked",
      StartTime: createDateTime(item.date, item.startTime),
      EndTime: createDateTime(item.date, item.endTime),
      IsAllDay: false,
      CategoryColor: facilityColor,
    };
  });

  const onEventRendered = (args) => {
    const categoryColor = args.data.CategoryColor;
    args.element.style.backgroundColor = categoryColor;
  };

  const onPopupOpen = (args) => {
    args.cancel = true;
  };

  const onCellClick = (args) => {
    args.cancel = true;
  };

  const onCellDoubleClick = (args) => {
    args.cancel = true;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm">
      <div className="flex items-center justify-between mb-6 border-b border-gray-100 pb-4">
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-[#363062] text-lg" />
          <div className="flex flex-col">
            <span className="text-xs text-gray-500">Selected Date</span>
            <span className="text-sm font-medium text-[#363062]">
              {date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </span>
          </div>
        </div>
        <button
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs hover:bg-gray-50 text-[#363062] transition-colors"
          onClick={() => setDateSelected(null)}
        >
          <FaTimesCircle className="text-xs" />
          <span>Reset</span>
        </button>
      </div>

      <div className="bg-gray-50 rounded-lg">
        <div className="calendar-container">
          <ScheduleComponent
            eventSettings={{
              dataSource: data,
              template: (props) => {
                return (
                  <div className="text-white text-xs p-1 rounded">
                    {props.Subject}
                  </div>
                );
              },
            }}
            eventRendered={onEventRendered}
            popupOpen={onPopupOpen}
            width="100%"
            height={350}
            currentView="Week"
            timeScale={{ interval: 60, slotCount: 1 }}
            rowAutoHeight={true}
            readOnly={true}
            cellClick={onCellClick}
            cellDoubleClick={onCellDoubleClick}
            selectedDate={date}
            cssClass="custom-schedule"
          >
            <ViewsDirective>
              <ViewDirective option="Day" />
              <ViewDirective option="Week" />
              <ViewDirective option="Month" />
            </ViewsDirective>
            <Inject services={[Day, Week, Month]} />
          </ScheduleComponent>
        </div>
      </div>

      <style jsx>{`
        :global(.custom-schedule.e-schedule) {
          background: white;
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #eee;
        }
        :global(.custom-schedule .e-schedule-toolbar) {
          background: #363062;
          padding: 8px;
        }
        :global(.custom-schedule .e-toolbar-item .e-tbar-btn) {
          color: white !important;
          background: transparent !important;
          border: none !important;
        }
        :global(.custom-schedule .e-toolbar-item.e-active .e-tbar-btn) {
          background: rgba(255, 255, 255, 0.1) !important;
        }
        :global(.custom-schedule .e-schedule-table) {
          border-color: #eee;
        }
        :global(.custom-schedule .e-current-day) {
          background-color: rgba(143, 205, 0, 0.1) !important;
        }
        :global(.custom-schedule .e-header-cells) {
          background-color: #f8f9fa;
        }
      `}</style>
    </div>
  );
}